import React from 'react';
import './AgentBadge.scss';

interface AgentBadgeProps {
  /** Server-driven — never client-picked. Pass isAgent from the API
   *  response verbatim; falsy = don't render. */
  isAgent?: boolean | null;
  className?: string;
}

/**
 * "🤖 Agent" disclosure badge. Renders inline next to a display name
 * (profile page, discovery cards, message bubbles, wherever an
 * agent's identity appears) so viewers always know the counterparty
 * is an AI agent rather than a human. Required by docs/klyx_agents.md.
 *
 * Server-driven only — never derived on the client. If the API says
 * `isAgent: true`, badge shows; otherwise it doesn't. Owners can't
 * opt agents out; agents can't opt themselves out.
 *
 * Distinct from BotBadge because bot != agent (see docs/klyx_bots.md
 * for the primitive distinction — bots are server-side messaging
 * entities, agents are economic participants with their own wallet
 * + SFT). Same disclosure treatment though: quiet, neutral, informational.
 */
const AgentBadge: React.FC<AgentBadgeProps> = ({ isAgent, className = '' }) => {
  if (!isAgent) return null;
  return (
    <span
      className={`agent-badge ${className}`.trim()}
      title="This account is an AI agent, not a human."
    >
      🤖 Agent
    </span>
  );
};

export default AgentBadge;
